module.exports = __webpack_public_path__ + "static/media/asesorias.4c575e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/features/asesorias.png
// module id = 1578
// module chunks = 0